import React, { ChangeEvent, useState, useEffect } from 'react'
import { ReportReferralParams } from '@/app/services/reportService/reportReferral'
import { Input } from '@/view/components/ui/input'
import { useDebounce } from '@/app/hooks/useDebounce'
import { Search } from 'lucide-react'

interface SearchProps {
  setParams: React.Dispatch<
    React.SetStateAction<ReportReferralParams | undefined>
  >
}

export const Searchs = ({ setParams }: SearchProps) => {
  const [searchValue, setSearchValue] = useState<string | undefined>(undefined)
  const debouncedSearchValue = useDebounce(500, searchValue)

  const handleSearchInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value
    setSearchValue(inputValue.replace(/[^a-zA-Z0-9\s]/g, ''))
  }

  useEffect(() => {
    if (debouncedSearchValue !== undefined) {
      setParams({
        search: debouncedSearchValue,
        skip: 0,
      })
    }
  }, [debouncedSearchValue, setParams])

  return (
    <div className="relative flex items-center gap-2">
      <Search size={20} className="z-2 absolute left-4 top-3" />
      <Input
        className="ml-1 w-96 rounded-3xl pl-10"
        placeholder="Pesquisar"
        onChange={handleSearchInputChange}
      />
    </div>
  )
}
